import { render, staticRenderFns } from "./knowledgeCommunity.vue?vue&type=template&id=10dd267a&scoped=true"
import script from "./knowledgeCommunity.vue?vue&type=script&lang=js"
export * from "./knowledgeCommunity.vue?vue&type=script&lang=js"
import style0 from "./knowledgeCommunity.vue?vue&type=style&index=0&id=10dd267a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd267a",
  null
  
)

export default component.exports